import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.move-accounts', {
        url: '/move-accounts',
        params: {accounts: []},
        component: 'companyUserDirectoriesManageUserMoveAccounts',
        resolve: {
            accounts,
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/move-accounts/move-accounts.state.js